import React from 'utils/react';
import CreatableSelect from 'react-select';
import Option from './Option';
import colourStyles from './colourStyles';

export default props => (
  <CreatableSelect {...props} components={{ Option }} styles={colourStyles} />
);
